import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import { Formik } from "formik"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useMemo } from "react"
import { Container } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import BottomFormFixed from "../../components/BottomFormFixed"
import Layout from "../../components/Layout"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import { useDeleteTheme, usePartialUpdateTheme, useTheme } from "../../hooks/themes"
import type { Theme } from "../../types"
import { initialValuesTheme, validationSchemaTheme } from "./ThemeCommon"
import ThemeForm from "./ThemeForm"

export default function ThemeUpdate() {
  const updateTheme = usePartialUpdateTheme()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: theme } = useTheme(Number(id))

  const deleteTheme = useDeleteTheme()

  const [modalStateDeleteTheme, modalActionsDeleteTheme] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesTheme(theme), [theme])
  const validationSchema = useMemo(() => validationSchemaTheme(), [])

  useBreadcrumbs([{ label: "Temi", href: "/themes/themes" }, { label: "Dettaglio Tema" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{theme?.name}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteTheme.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              if (typeof values.image === "string") {
                delete values.image
              }
              return updateTheme.mutateAsync(values as Theme).then(() => {
                navigate(`/themes/themes`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <ThemeForm />
                </Container>
                <BottomFormFixed url="/themes/themes" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteTheme.isOpen}
        onClose={modalActionsDeleteTheme.close}
        onDelete={() => {
          return deleteTheme.mutateAsync(theme?.id).then(() => {
            navigate(`/themes/themes`)
          })
        }}
        message="Sei sicuro di voler eliminare il tema?"
        title="Elimina Tema"
      />
    </Layout>
  )
}
